import { FETCH_CREDIT, FETCH_CREDIT_SUCCESS, FETCH_CREDIT_ERROR, 
    TOGGLE_CREDIT, TOGGLE_ALL_CREDIT, CHANGE_PAYMENT_AMOUNT, CHANGE_ADHOC_PAYMENT } from '../action-types/credit';
  
  export const fetchCredit = (currencyCode) => {
  
    return async dispatch => {
      try {
        dispatch({
          type: FETCH_CREDIT
        })
  
        let token = localStorage.getItem('token');
        let code = localStorage.getItem('code');
        const response = await fetch(`${process.env.REACT_APP_API_HOST}${process.env.REACT_APP_API_INVOICES_URL}?invoice-code=${currencyCode}&customer-code=${encodeURIComponent(code)}&type=Others`,
        {
          method: 'GET',
          headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
            Authorization: `${process.env.REACT_APP_API_TOKEN}`
          }})
        //const response = await fetch(`${'https://api.myjson.com/bins/oq7ly'}?token=${token}&code=${code}&currency=${currencyCode}`)
        const data = await response.json();
        if (data && data.length) {
          dispatch({type: FETCH_CREDIT_SUCCESS, payload: data.map(invoice => {
            return {...invoice, selected: false}
          })})
        } else {
          dispatch({type: FETCH_CREDIT_ERROR, payload: data})
        }
      } catch(error) {
        dispatch({type: FETCH_CREDIT_ERROR, payload: 'Server unreachable, Please contact customer support'})
      }
    }
  }
  
  export const toggleCredit = (entryNo) => {
    return dispatch => {
      dispatch({type: TOGGLE_CREDIT, payload: entryNo});
    }
  }
  
  export const toggleAllCredit = (checked) => {
    return dispatch => {
      dispatch({type: TOGGLE_ALL_CREDIT, payload: checked});
    }
  }
  
  export const changePaymentAmount = (entryNo, paymentAmount) => {
    return dispatch => {
      dispatch({type: CHANGE_PAYMENT_AMOUNT, payload: {entryNo, paymentAmount}});
    }
  }
  
  export const changeCreditAdhocAmount = (adhocPaymentEnabled, adhocPayment) => {
    return dispatch => {
      dispatch({type: CHANGE_ADHOC_PAYMENT, payload: {adhocPaymentEnabled, adhocPayment}});
    }
  }


// WEBPACK FOOTER //
// ./src/actions/credit.js